<template>
    <div id="device-report" :style="activeName!='0'?{background:'#fff'}:{}">
        <div class="top">
            <div class="tabs">
                <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top:20px">
                    <el-tab-pane :disabled="!permission.btn_report_deviceSummary" label="汇总" name="0"></el-tab-pane>
                    <el-tab-pane :disabled="!permission.btn_report_listDevice"  label="设备运维" name="1"></el-tab-pane>
                    <el-tab-pane :disabled="!permission.btn_report_listWorkOrder" label="维保工单" name="2"></el-tab-pane>
                </el-tabs>
            </div>
            <div class="table_searchbar">
                <el-row :gutter="W?20:0">
                    <el-col :span="W?8:10" style="display:flex">
                        <div class="" @keydown.enter="clickSearch()">
                            <span class="title">日期查询：</span>
                            <el-date-picker style="width:230px" v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期" value-format="yyyy-MM-dd"   ></el-date-picker>
                        </div>
                        <el-button icon="el-icon-search" size='mini' type="primary" @click="clickSearch(1)" style="margin-left:40px">查询</el-button>
                    </el-col>
                    <el-col :span="W?16:14" >
                        <div style="text-align:right">
                            
                            <el-button icon="el-icon-download" size='mini'  @click="exportList" v-if="permission.btn_report_exportWorkOrder&&activeName!='0'" >导出</el-button>
                            <el-button  size="mini" v-if="activeName!='0'"  @click='printOrderInfo'>打印报表</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div  v-if='activeName=="0"' class="content">
            <div class="left-item">
                <div class="time-box">
                    <span class="time-text">停机总时长</span>
                    <div class="time-number">
                        <div class="number-item">
                            <span>{{stopTotalTime[0]}}</span>
                        </div>
                        <div class="number-item">
                            <span>{{stopTotalTime[1]}}</span>
                        </div>
                        <div class="number-item">
                            <span>{{stopTotalTime[2]}}</span>
                        </div>
                        <div class="number-item">
                            <span>{{stopTotalTime[3]}}</span>
                        </div>
                        <span class="hour">小时</span>
                    </div>
                </div>
                <div class="percentage">
                    <span class="title-text">设备完好率</span>
                    <div style="text-align: center;">
                        <el-progress type="circle" :percentage="deviceRegularRatio" color="rgba(64,158,255,1.00)" :stroke-width='9' ></el-progress>
                    </div>
                </div>
                <div class="percentage">
                    <span class="title-text">设备利用率</span>
                    <div style="text-align: center;">
                        <el-progress type="circle" :percentage="deviceUseRatio" color="rgba(232,96,103,1.00)" :stroke-width='9' ></el-progress>
                    </div>
                </div>
                <div class="percentage" style="margin-bottom:0px">
                    <span class="title-text">维保完成率</span>
                    <div style="text-align: center;">
                        <el-progress type="circle" :percentage="workOrderCompletionRatio" color="rgba(255,190,0,1.00)" :stroke-width='9' ></el-progress>
                    </div>
                </div>
            </div>
            <div class="center-item">
                <div class="device-run-status" ref='deviceRunStatus' height='100%' width='100%'></div>
                <div class="device-care-detail" ref='deicecareDetail' height='100%' width='100%'></div>
            </div>
            <div class="right-item">
                <div class="stopTime-deviceTop">
                    <span >停机时长前五设备</span>
                    <el-table :data="stopTimeDeviceTop"   width='90%'   border>
                            <el-table-column fixed prop="deviceCode" label="设备编号" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="organizationName" label="部门" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="stopTime" label="停机时长" show-overflow-tooltip></el-table-column>
                    </el-table>
                </div>
                <div class="workOrder-deviceTop">
                    <span>维修次数前五设备</span>
                    <el-table :data="workOrderDeviceTop"      border>
                            <el-table-column fixed prop="deviceCode" label="设备编号" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="organizationName" label="部门" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="workOrderAmount" label="维修次数" show-overflow-tooltip></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>

        <div  v-if='activeName=="1"' style="padding:10px 20px;background:#fff">
            <el-row class='tab'>
                <el-row class='table-wrap'  >
                    <div style="margin-top:10px;">
                        <el-table :data="orderList" @sort-change='sortChangeEvent' :default-sort='defaultSort'  width=80%  class="table_data"   border>
                            <el-table-column fixed prop="deviceCode" label="设备编号" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="deviceName" label="设备名称" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="workDays" label="工作天数" sortable="custom" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="stopTimeSpan" label="停机时长" sortable="custom" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="activation" label="计划稼动率"  sortable="custom" :formatter="parsePlanRatio" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="actualActivation" label="实际稼动率" sortable="custom" :formatter="parseRatioActiva" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="maintenanceAmount" label="保养次数" sortable="custom" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="repairAmount" label="维修次数" sortable="custom" show-overflow-tooltip></el-table-column>
                        </el-table>
                    </div>
                </el-row>
                <div class="page" v-if="page.isShow">
                    <div class="total_page"><span> 共{{page.total}}条 </span></div>
                    <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                        <el-pagination background @size-change="sizeChange" layout=" sizes, prev, pager, next, jumper" :page-count="page.total"
                        :page-sizes="[10, 20, 30, 50,100]" :page-size.sync="page.pageSize"  :total="page.total" @current-change="pageChange" :current-page.sync="page.currentPage"></el-pagination>
                    </div>
                </div>
            </el-row>
        </div>

        <div v-if='activeName=="2"' style="padding:10px 20px;background:#fff">
            <el-row style="margin-top:10px;" class="summary">
                <span>工单总数：{{workOrderAmount}}</span>
                <span>完成工单数：{{workOrderFinishedAmount}}</span>
                <span>工单完成率：{{workOrderFinishedRate}}%</span>
            </el-row>
            <el-row class='tab'>
                <el-row class='table-wrap'  >
                    <div style="margin-top:10px;">
                        <el-table :data="orderList" @sort-change='sortChangeEvent1' :default-sort='defaultSort1'    width=80%  class="table_data"   border>
                            <el-table-column fixed prop="workerName" label="工人名称" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="maintenanceFinishedAmount" sortable="custom" label="完成保养数" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="maintenanceAmount" label="保养工单数" sortable="custom" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="repairFinishedAmount" label="完成维修数" sortable="custom" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="repairAmount" label="维修工单数" sortable="custom"  show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="finishedRate" label="总完成率" sortable="custom" :formatter="parseRatio" show-overflow-tooltip></el-table-column>
                            <el-table-column fixed prop="handleTime" label="平均响应时间(时)" sortable="custom" show-overflow-tooltip></el-table-column>
                        </el-table>
                    </div>
                </el-row>
                <div class="page" v-if="page.isShow">
                    <div class="total_page"><span> 共{{page.total}}条 </span></div>
                    <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                        <el-pagination background @size-change="sizeChange" layout=" sizes, prev, pager, next, jumper" :page-count="page.total"
                        :page-sizes="[10, 20, 30, 50,100]" :page-size.sync="page.pageSize"  :total="page.total" @current-change="pageChange" :current-page.sync="page.currentPage"></el-pagination>
                    </div>
                </div>
            </el-row>
            <div  style="position: fixed;top:-9999999px;left-999999px" >
                <div ref="printOrder">
                    <PrintReport ref="info"  :activeName='activeName' :viewData='viewData'></PrintReport>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import PrintReport from "./PrintReport.vue";
export default {
    name: "DevicecareReport",
    components:{PrintReport},
    data() {
        return {
            orderType:'DESC',
            orderColumn: null,//排序列
            defaultSort: {prop: 'stopTimeSpan', order: 'descending'},//默认排序设置
            defaultSort1: {prop: 'maintenanceFinishedAmount', order: 'descending'},//默认排序设置
            deviceRegularRatio:0,
            deviceUseRatio:0,
            stopTotalTime:'0000',
            workOrderCompletionRatio:0,
            stopTimeDeviceTop: [],
            workOrderDeviceTop: [],
            deviceStatus:[],
            workorderPlan:[],
            workorderActual:[],
            fristLoad:false,
            activeName:'0',
            tableData:[],
            now : new Date(),
            page: {
                isShow: true,
                total: 0,
                currentPage: 1,
                pageSize: 10,
            },
            W:false,
            searchForm:{},
            dateRange: [new Date(new Date().valueOf() - 30 * 24 * 60 * 60 * 1000), new Date()],
            orderList:[],
            viewData:[],
            workOrderAmount:0,
            workOrderFinishedAmount:0,
            workOrderFinishedRate:0,
            permission:JSON.parse(localStorage.getItem("permission"))
        };

    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    mounted: function() {

        let w  = document.documentElement.clientWidth || document.body.clientWidth;
        w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
        this.loadTabulateData()
    },
    methods: {
        sortChangeEvent(param){
            let orderType = param.order;
            let orderColumn = param.prop;
            if(orderType == 'descending'){
                this.orderType = 'DESC';
            }else if(orderType == 'ascending'){
                this.orderType = 'ASC';
            }else{
                this.orderType = orderType;
            }
            this.orderColumn = orderColumn;
            this.search(this.tableCurrentPage);
        },
        sortChangeEvent1(param){
            let orderType = param.order;
            let orderColumn = param.prop;
            if(orderType == 'descending'){
                this.orderType = 'DESC';
            }else if(orderType == 'ascending'){
                this.orderType = 'ASC';
            }else{
                this.orderType = orderType;
            }
            this.orderColumn = orderColumn;
            this.search(this.tableCurrentPage);
        },
        handleClick(){
            if(this.activeName=='0'){
                this.loadTabulateData()
            }else if(this.activeName=='1'){
                this.search()
            }else{
                this.search()
            }
        },
        //给定一个数字填充固定长度
        pad(num, n) {
            var len = num.toString().length;
            while(len < n) {
                num = "0" + num;
                len++;
            }
            return ''+num;
        },
        loadTabulateData(){
            let dateRange = this.dateRange;
            let [startDate,endDate] = dateRange
            startDate = commonUtils.timestampToDate(new Date(startDate).getTime(),true).trim()
            endDate = commonUtils.timestampToDate(new Date(endDate).getTime(),true).trim()
            this.$RequestUtil.get({
                url:'/api/report/listDeviceSummaryReport',
                type:'sync',
                params: {
                   startDate,
                   endDate,
                },
                success: (res) => {
                    let {code,msg,message,data} = res
                    if(code==0){
                        this.deviceRegularRatio = data.deviceRegularRatio
                        this.deviceUseRatio = data.deviceUseRatio
                        this.stopTotalTime = this.pad(Math.round(data.stopTotalTime),4)
                        this.workOrderCompletionRatio = data.workOrderCompletionRatio
                        this.stopTimeDeviceTop = data.stopTimeDeviceTop
                        this.workOrderDeviceTop = data.workOrderDeviceTop
                        this.deviceStatus = [data.deviceStatus.errorStartAmount,data.deviceStatus.actualStartAmount,data.deviceStatus.planStartAmount,data.deviceStatus.deviceAmount]
                        this.workorderPlan = [data.workorderStatus.planWorkOrderDeviceAmount,data.workorderStatus.planMaintenanceWorkOrderAmount,data.workorderStatus.planRepairWorkOrderAmount]
                        this.workorderActual = [data.workorderStatus.actualWorkOrderDeviceAmount,data.workorderStatus.actualMaintenanceWorkOrderAmount,data.workorderStatus.actualRepairWorkOrderAmount]
                        this.deviceRunningStatus()
                        this.deviceCareDetail()
                    }else{
                       this.$message.error(res.msg||res.message)
                    }
                }
            })
        },
        //加载打印数据
        async loadPrintData(){
            var dateRange = this.dateRange;
            if (dateRange == null || dateRange[0] == null || dateRange[1] == null) {
                this.$message.warning("请选择完整的时间区间");
                return;
            }
            let [startDate,endDate] = dateRange
            startDate = commonUtils.timestampToDate(new Date(startDate).getTime(),true)
            endDate = commonUtils.timestampToDate(new Date(endDate).getTime(),true)
            let url = ''
            if(this.activeName=='1'){
                url = '/api/report/listDevice'
            }
            if(this.activeName=='2'){
                url = '/api/report/listWorkOrder'
            }
            let {data} =await this.$RequestUtil.getAsync({url,type: 'sync',params: {startDate, endDate},})
            return data
        },
        //打印订单
        async printOrderInfo(){
            let data = await this.loadPrintData()
            let createData = []
            let arr = []
            if(this.activeName=='1'){
                arr = [
                    {key:'deviceCode',value:'设备编号'},
                    {key:'deviceName',value:'设备名称'},
                    {key:'workDays',value:'工作天数'},
                    {key:'stopTimeSpan',value:'停机时长'},
                    {key:'activation',value:'计划稼动率'},
                    {key:'actualActivation',value:'实际稼动率'},
                    {key:'maintenanceAmount',value:'保养次数'},
                    {key:'repairAmount',value:'维修次数'},
                ]
                data.forEach(item=>{
                    item.activation = this.parsePlanRatio(item)
                    item.actualActivation = this.parseRatioActiva(item)
                })
                createData = data
            }
            if(this.activeName=='2'){
                arr = [
                    {key:'workerName',value:'工人名称'},
                    {key:'maintenanceFinishedAmount',value:'完成保养数'},
                    {key:'maintenanceAmount',value:'保养工单数'},
                    {key:'repairFinishedAmount',value:'完成维修数'},
                    {key:'repairAmount',value:'维修工单数'},
                    {key:'finishedRate',value:'总完成率'},
                    {key:'handleTime',value:'平均响应时间(时)'},
                ]
                data.workOrderReportList.forEach(item=>{
                    item.finishedRate = this.parseRatio(item)
                })
                createData = data.workOrderReportList
            }

            this.$nextTick(()=>{
                var printWindow = window.open(""); //新打开一个空窗口
                printWindow.document.body.innerHTML = commonUtils.createTable(arr,createData)
                printWindow.document.close(); //在IE浏览器中使用必须添加这一句
                printWindow.focus(); //在IE浏览器中使用必须添加这一句
                setTimeout(()=>{
                    printWindow.print(); //打印
                    printWindow.close(); //关闭窗口

                }, 0);
            })
        },
        sizeChange(ev){
           this.$set(this.page,'pageSize',ev)
            this.search();
        },
        init: function() {
            this.search();
        },
        exportList: function() {
            let dateRange = this.dateRange;
            if (dateRange == null || dateRange[0] == null || dateRange[1] == null) {
                this.$message.warning("请选择完整的时间区间");
                return
            }
            this.export();
        },
        clickSearch: function() {
            var dateRange = this.dateRange;
            if (dateRange == null || dateRange[0] == null || dateRange[1] == null) {
                this.$message.warning("请选择完整的时间区间");
                return
            }
            if(this.activeName=='0'){
                this.loadTabulateData()
            }else{
                this.search(1);
            }
        },
        pageChange(pageNum) {
            this.search(pageNum);
        },

        export: function() {
           
            this.$confirm('是否确认导出?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let dateRange = this.dateRange;
                let [startDate,endDate] = dateRange
                startDate = commonUtils.timestampToDate(new Date(startDate).getTime(),true)
                endDate = commonUtils.timestampToDate(new Date(endDate).getTime(),true)
                let params = {startDate, endDate}
                 let url = ''
                 let text = ''
                if(this.activeName=='1'){
                    url = '/api/report/exportDevice'
                    text = '设备运维报表.xls'
                }
                if(this.activeName=='2'){
                    url = '/api/report/exportWorkOrder'
                    text = '设备保养工单报表.xls'
                }
                let str = '?'
                for(let p in params){
                    if(params[p]||params[p]===0){
                        str += `${p}=${params[p]}&`
                    }
                }
                let {code,data} = await this.$RequestUtil.getAsync({url:"/api/auth/checkToken",type:'sync',params: {},})
                if(data==0||(code!=0)){
                    this.$message.error('当前登录已过期')
                    localStorage.removeItem("token");
                    localStorage.removeItem("username");
                    localStorage.removeItem("permission");
                    this.$router.push({path:"/login"})
                    return
                }
                if(str.endsWith('&')){
                    str = str.slice(0,str.length-1)
                }
                str+=`&token=${localStorage.getItem("token")}`
                url = url+str;
                let res = await this.$RequestUtil.getAsync({url,type:'sync',dataType:'blob',params: {},})
                let xls =  new Blob([res], {type: 'application/application/vnd.ms-excel;charset=utf-8'})
                var downloadElement = document.createElement('a');
            　　var href = window.URL.createObjectURL(xls); //创建下载的链接
            　　downloadElement.href = href;
            　　downloadElement.download = text; //下载后文件名
            　　document.body.appendChild(downloadElement);
            　　downloadElement.click(); //点击下载
            　　document.body.removeChild(downloadElement); //下载完成移除元素
            　　window.URL.revokeObjectURL(href); //释放掉blob对象 

            }).catch(() => {});
        },
        search:function(pageNum){
            if(pageNum == null || pageNum instanceof KeyboardEvent){
                pageNum = 1;
            }
            this.page.currentPage = pageNum
            var dateRange = this.dateRange;
            if (dateRange == null || dateRange[0] == null || dateRange[1] == null) {
                this.$message.warning("请选择完整的时间区间");
                return;
            }
            let [startDate,endDate] = dateRange
            let url = ''
            if(this.activeName=='1'){
                url = '/api/report/listDevice'
            }
            if(this.activeName=='2'){
                url = '/api/report/listWorkOrder'
            }
            this.$RequestUtil.get({
                url,
                type:'sync',
                params: {
                    startDate,
                    endDate,
                    pageNum: pageNum,
                    orderType:this.orderType,
                    pageSize: this.page.pageSize,
                },
                success: (res) => {
                    if(res.code == 0){
                        if(this.activeName=='1'){
                            this.orderList = res.data
                        }else{
                            this.orderList = res.data.workOrderReportList;
                            this.workOrderAmount = res.data.workOrderAmount
                            this.workOrderFinishedAmount = res.data.workOrderFinishedAmount
                            this.workOrderFinishedRate = res.data.workOrderFinishedRate
                        }
                        this.page.total = res.totalPages;
                        if(res.totalPages == 0){
                            this.$message.warning('查询不到符合条件的数据');
                        }
                    }else{
                        this.$message.error(res.message||res.msg)
                    }
                }
            });
        },
        parseOrderDate:function(time){
            if(time != null){
                let dateString = commonUtils.timestampToDate(time.orderTime,true);
                return dateString;
            }
        },
        parseRatio:function(rowData){
            if(rowData.finishedRate != null){
                return rowData.finishedRate+'%';
            }
        },
        parsePlanRatio(rowData){
            if(rowData.activation != null){
                return rowData.activation+'%';
            }
        },
        parseRatioActiva(rowData){
            if(rowData.actualActivation != null){
                return rowData.actualActivation +'%'
            }
        },
        parseCount(rowData){
            if(!rowData.count){
                return 0
            }else{
                return rowData.count
            }
        },

        //设备运行情况
        deviceRunningStatus(){
          let that = this
            setTimeout(()=>{
                if(!this.$refs.deviceRunStatus){
                    return
                }
                let deviceRunBar = this.$Echarts.getInstanceByDom(this.$refs.deviceRunStatus)
                if (deviceRunBar == null) {
                    deviceRunBar = this.$Echarts.init(this.$refs.deviceRunStatus);
                }
                let option = {
                    title: {
                        text: '设备运行情况',
                        textStyle:{
                            lineHeight: 40,
                            fontSize:16,
                            color:'#303133',
                            fontFamily: "PingFang-SC-Bold",
                            fontWeight :'normal'
                        },
                    },

                    color:'rgba(64,158,255,1.00)',
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: ''
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        show : false,
                    },
                    yAxis: {
                        type: 'category',
                        data: [ '故障停机数', '实际开动数','理论开动数','设备总数'],
                        axisTick:{       //y轴刻度线
                            show:false
                        },
                        splitLine: {     //网格线
                            show: false
                        },
                    },
                    series: [
                        {
                            type: 'bar',
                            data: that.deviceStatus,
                            barMaxWidth: 40,
                           
                            itemStyle: {        //上方显示数值
                                normal: {
                                    label: {
                                        show: true, //开启显示
                                        position: 'insideRight', //在上方显示
                                        textStyle: { //数值样式
                                            color: '#fff',
                                            fontSize: 11,
                                        }
                                    }
                                }
                            }
                        },
                    ]
                };
                deviceRunBar.setOption(option,true);
            },0)
        },

        //设备维保情况
        deviceCareDetail(){
          let that = this
            setTimeout(()=>{
                if(!this.$refs.deicecareDetail){
                    return
                }
                let deicecareBar = this.$Echarts.getInstanceByDom(this.$refs.deicecareDetail)
                if (deicecareBar == null) {
                    deicecareBar = this.$Echarts.init(this.$refs.deicecareDetail);
                }
                let option = {
                    title: {
                        text: '设备维保情况',
                        textStyle:{
                            lineHeight: 40,
                            fontSize:16,
                            color:'#303133',
                            fontFamily: "PingFang-SC-Bold",
                            fontWeight :'normal'
                        },
                    },
                    color: ['rgba(64,158,255,1.00)', 'rgba(0,197,210,1.00)', ],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: ''
                        }
                    },
                    legend: {
                        right:10,
                        top:20,
                        data: ['计划数', '完成数', ]
                    },
                    xAxis: [
                        {
                            type: 'category',
                            axisTick: {show: false},
                            splitLine:{ show:false},
                            data: ['维保台数', '保养工单', '维修工单'],
                        },
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            axisTick: {show: false},
                            splitLine:{ show:false},
                        },
                    ],
                    axisTick: { show:false},
                    splitLine:{ show:false},
                    series: [
                        {
                            name: '计划数',
                            type: 'bar',
                            barGap: 0.1,
                            data: that.workorderPlan,
                            "axisTick":{       //y轴刻度线
                                "show":false
                            },
                            "splitLine": {     //网格线
                                "show": false
                            },
                            barMaxWidth: 40,
                            itemStyle: {        //上方显示数值
                                normal: {
                                    label: {
                                        show: true, //开启显示
                                        position: 'top', //在上方显示
                                        textStyle: { //数值样式
                                            color: 'black',
                                            fontSize: 14
                                        }
                                    }
                                }
                            }
                        },
                        {
                            name: '完成数',
                            type: 'bar',
                            data: that.workorderActual,
                            "axisTick":{       //y轴刻度线
                                "show":false
                            },
                            "splitLine": {     //网格线
                                "show": false
                            },
                            barMaxWidth: 40,
                            itemStyle: {        //上方显示数值
                                normal: {
                                    label: {
                                        show: true, //开启显示
                                        position: 'top', //在上方显示
                                        textStyle: { //数值样式
                                            color: 'black',
                                            fontSize: 14
                                        }
                                    }
                                }
                            }
                        },
                    ]
                }
                deicecareBar.setOption(option,true);
            },0)
        },
    }
};
</script>

<style scoped>
.top{
    width: 100%;
    height: 130px;
    background: #ffff;
    margin-top: -20px;
}
.tabs{
    padding: 5px 20px;
}
.table_searchbar{
    padding: 0 20px;
}
.content{
    /* width: 102.6%; */
    height: auto;
    margin-top: 20px;
    display: flex;
}
.left-item{
    flex: 2;
    margin-right: 20px;

}
.time-box{
    height: 136px;
    width: 100%;
    background: #fff;
     margin-bottom: 20px;
     
}

.time-text{
    font-size: 16px;
    color: #303133;
    height: 50px;
    line-height: 44px;
    padding-left: 20px;
    font-family: "PingFang-SC-Bold"
}
.time-number{
    margin: 0 20px;
    display: flex;
}
.number-item{
    /* width: 40px; */
    height: 60px;
    background: #5584BF;
    text-align: center;
    margin-right: 16px;
    flex: 1;
    padding: 0 8px;
}
.number-item span{
    font-size: 32px;
    font-family: Bebas;
    line-height: 60px;
    color: #fff;
}
.hour{
    font-size: 16px;
    line-height: 70px;
    width: 32px;
}

.percentage{
    height: 195px;
    width: 100%;
    background: #fff;
    margin-bottom: 20px;
}
.percentage .title-text{
    height: 50px;
    padding-left: 20px;
    font-size: 16px;
    color: #303133;
    display: inline-block;
    width: 100%;
    line-height: 50px;
    font-family: "PingFang-SC-Bold"
}

.center-item{
    flex: 5;
    margin-right: 20px;
    display: flex;
    flex-direction:column;
}

.device-run-status{
    width: 100%;
    margin-bottom: 25px;
    flex: 1;
    background: #fff;
}


.device-care-detail{
    flex: 1;
    background: #fff;
}


.right-item{
    flex: 3;
    display: flex;
    flex-direction:column;
}

.stopTime-deviceTop{
    margin-bottom: 25px;
    flex: 1;
    background: #fff;
    padding: 0 20px;
}
.stopTime-deviceTop span,.workOrder-deviceTop span{
    font-size: 16px;
    color: #303133;
    line-height: 50px;
    font-family: "PingFang-SC-Bold"
}
.workOrder-deviceTop{
    flex: 1;
    background: #fff;
    padding: 0 20px;
}

.summary span{
    font-size: 14px;
    margin-right: 20px;
}
#device-report{
    overflow: hidden;
    overflow-y: auto;
    width: 102.6%;
    scrollbar-width: none;
    height: 102%;
    margin-left: -20px;
    margin-top:-20px;
    background: #f6f7fa;
    height: 100%;
}
#device-report::-webkit-scrollbar {
    display: none;
}
.el_progress--cricle{
    
}
.search-input-row{
    margin-top: 10px;
}
.page{
    display: flex;
    justify-content: flex-end;
}
.total_page{
    margin-top: 16px;
    margin-right: 16px;
    color:#606266;
    font-size: 14px;
}
@media screen and (max-width: 1380px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }

    .summary span{
        font-size: 12px;
    }
}
@media screen and (max-width: 1440px) {
    #device-report{
        width: 103.6%;
    }
}
@media screen and (max-width: 1366px) {
    #device-report{
        width: 103.8%;
        height: 110%;
    }
    .content{
        padding-bottom: 40px
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 180px !important;
    }
}
@media screen and (max-width: 1280px){
    #device-report{
        width: 104.2%;
    }
    .number-item {
        padding: 0 6px;
    }
    .number-item span{
        font-size: 26px
    }
    .hour{
        font-size: 14px;
        width: 28px;
    }
}
</style>
<style>
.el-table  .el-table__body .rowbg{
    background:#ffffff !important;
}
.el-table  .el-table__body  .rowbg:hover>td{ background: #ffffff !important; }
#device-report .el-progress--circle .el-progress__text{
    font-size: 28px !important;
    color:#303133;
    font-family: 'Bebas';
}
</style>




// WEBPACK FOOTER //
// src/views/report/devicecareReport.vue